import { useLocalization } from '@ais-ui/locale-management';
import { MessageForm } from './MessageForm';
import { UseFormReturn } from 'react-hook-form';
import { MessagesFormValues } from './useMessagesForm';

interface SettingsMessagesPageProps {
  form: UseFormReturn<MessagesFormValues>;
}

export function SettingsMessagesPage({ form }: SettingsMessagesPageProps) {
  const { messages } = useLocalization();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsMessagesListTitle}
        </h3>
      </div>
      <MessageForm form={form} />
    </div>
  );
}
